import { Div } from '../../../base/components/native/div'
import { CENTER } from '../../../base/helpers/style'
import { IProductVariant } from '../../../interfaces/product'
import { Color } from './color'

export const Colors = (variants: IProductVariant[]) => {

    const base = Div()
    const codes = [
        { name: 'white', code: '#eee8e8' },
        { name: 'black', code: '#1e1e20' },
        { name: 'yellow', code: '#d9a300' },
        { name: 'green', code: '#358536' },
        { name: 'blue', code: '#34267d' },
        { name: 'red', code: '#ae092a' },
    ]
    variants.forEach((variant: IProductVariant) => {
        const colorOption = variant['color']
        const { code, name } = codes.find(c => c.name === colorOption)
        const colorDiv = Color(name, code)
        base.append(colorDiv)
        colorDiv.on('click', (code: string) => base.emit('select', { name: code }))
    })

    base.cssClass({
        ...CENTER,
        margin: '5px'
    })

    return base
}